"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMoralisAuth = void 0;
var functions_1 = require("firebase/functions");
var auth_1 = require("firebase/auth");
function getMoralisAuth(app, options) {
    var _a, _b, _c;
    if ((options === null || options === void 0 ? void 0 : options.regionOrCustomDomain) && (options === null || options === void 0 ? void 0 : options.functions)) {
        throw new Error('You cannot set "regionOrCustomDomain" and "functions" parameters at the same time');
    }
    return {
        functionNamePrefix: (_a = options === null || options === void 0 ? void 0 : options.functionNamePrefix) !== null && _a !== void 0 ? _a : 'ext-moralis-auth-',
        auth: (_b = options === null || options === void 0 ? void 0 : options.auth) !== null && _b !== void 0 ? _b : (0, auth_1.getAuth)(app),
        functions: (_c = options === null || options === void 0 ? void 0 : options.functions) !== null && _c !== void 0 ? _c : (0, functions_1.getFunctions)(app, options === null || options === void 0 ? void 0 : options.regionOrCustomDomain),
    };
}
exports.getMoralisAuth = getMoralisAuth;
//# sourceMappingURL=getMoralisAuth.js.map